import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { checkoutReducer, CheckoutState } from './checkout.reducer';
import {
  loyaltyProgramReducer,
  LoyaltyProgramState,
} from './loyalty-program.reducer';
import { membershipReducer, MembershipState } from './membership.reducer';

export interface TransferConnectV2State {
  checkout: CheckoutState;
  loyaltyProgram: LoyaltyProgramState;
  membership: MembershipState;
}

export const reducers: ActionReducerMap<TransferConnectV2State> = {
  // @ts-ignore
  checkout: checkoutReducer,
  // @ts-ignore
  loyaltyProgram: loyaltyProgramReducer,
  // @ts-ignore
  membership: membershipReducer,
};

export const getTransferConnectState =
  createFeatureSelector<TransferConnectV2State>('transferConnectV2');
